import React from "react";
import {
  Box,
  Grid,
  TextField,
  Typography,
  InputAdornment,
} from "@mui/material";
import RequiredLabel from "../../shared/RequiredLabel";

const MinMaxInput = ({
  label,
  nameMin,
  nameMax,
  valueMin,
  valueMax,
  onChange,
  placeholderMin = "",
  placeholderMax = "",
  unit = "",
  isRequired = false,
  errorMin = false,
  errorMax = false,
}) => {
  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <Typography sx={{ fontSize: 14 }}>{label}</Typography>
        <RequiredLabel show={isRequired} />
      </Box>

      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={5.5}>
          <TextField
            fullWidth
            name={nameMin}
            type="number"
            value={valueMin}
            onChange={onChange}
            error={errorMin}
            placeholder={placeholderMin}
            sx={{
              "& .MuiOutlinedInput-root input": {
                boxShadow: "none",
                outline: "none",
              },
            }}
            InputProps={{
              endAdornment: unit && (
                <InputAdornment position="end">{unit}</InputAdornment>
              ),
            }}
          />
        </Grid>

        <Grid item xs={12} sm={1} sx={{ textAlign: "center" }}>
          <Typography sx={{ mx: 1 }}>〜</Typography>
        </Grid>

        <Grid item xs={12} sm={5.5}>
          <TextField
            fullWidth
            name={nameMax}
            type="number"
            value={valueMax}
            onChange={onChange}
            error={errorMax}
            placeholder={placeholderMax}
            sx={{
              "& .MuiOutlinedInput-root input": {
                boxShadow: "none",
                outline: "none",
              },
            }}
            InputProps={{
              endAdornment: unit && (
                <InputAdornment position="end">{unit}</InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default MinMaxInput;
